import {makeStyles} from "@material-ui/core";
import { TextField } from "@material-ui/core";
import styled from 'styled-components';

export const FProveedoresStyle = makeStyles((theme) => ({
  textField: {
    width: "90%",
    margin: "5px",
    paddingBottom: 0,
    fontWeight: 500,
  },
  textFieldMultiLinea: {
    width: "97%",
    margin: "5px",
    paddingBottom: 0,
    fontWeight: 500,
  },
  formControl: {
    width: "90%",
    margin: "5px",
  },
  containerSpacing: {
    margin: "10px 0",
  },
  modalBotones: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  modalBotonesCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalBoton: {
    margin: "1px 0",
    width: "20%",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "900px",
    margin: "0 auto",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "none",
    boxShadow: theme.shadows[10],
    padding: theme.spacing(1, 2, 1),
  },
  }));


export const StyledTextField = styled(TextField)`
  label.focused {
    color: #1976D2; 💚
  }
  .MuiOutlinedInput-root {
    fieldset {
      border-color: #757575; 💔
    }
  &:hover fieldset {
    border-color: #BBDEFB; 💛
  }
  &.Mui-focused fieldset {
    border-color: #1976D2; 💚
  }
}
`;